export default "/react/modal-edtech-5bb20126.png";